<template>
    <div class="mt-5 mb-10">
        <section>
            <v-row>
                <v-col cols="12" md="4">
                    <v-card flat class="mb-4">
                        <v-card-text class="d-flex align-center gap-15 pa-3">
                            <div>
                                <v-img
                                    :src="
                                        require('@/assets/apps/total_consultant.svg')
                                    "
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Total Konsultan
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{ formatNumber(data.total) }}
                                    <span class="font-size-12 font-weight-500">
                                        Konsultan
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card flat>
                        <v-card-text class="d-flex align-center gap-10 pa-3">
                            <div>
                                <v-img
                                    :src="
                                        require('@/assets/apps/total_consultant_active.svg')
                                    "
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Total Konsultan Aktif
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{ formatNumber(data.active) }}
                                    <span class="font-size-12 font-weight-500">
                                        Konsultan
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card flat>
                        <v-card-text class="d-flex align-center gap-10 pa-3">
                            <div>
                                <v-img
                                    :src="
                                        require('@/assets/apps/total_consultant_nonactive.svg')
                                    "
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Total Konsultan Nonaktif
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{ formatNumber(data.non_active) }}
                                    <span class="font-size-12 font-weight-500">
                                        Konsultan
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card flat>
                        <v-card-text class="d-flex align-center gap-10 pa-3">
                            <div>
                                <v-img
                                    :src="
                                        require('@/assets/apps/total_consultant_online.svg')
                                    "
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Total Konsultan Online
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{ formatNumber(data.online) }}
                                    <span class="font-size-12 font-weight-500">
                                        Konsultan
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card flat>
                        <v-card-text class="d-flex align-center gap-10 pa-3">
                            <div>
                                <v-img
                                    :src="
                                        require('@/assets/apps/total_consultant_busy.svg')
                                    "
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Total Konsultan Sibuk
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{ formatNumber(data.busy) }}
                                    <span class="font-size-12 font-weight-500">
                                        Konsultan
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" md="4">
                    <v-card flat>
                        <v-card-text class="d-flex align-center gap-10 pa-3">
                            <div>
                                <v-img
                                    :src="
                                        require('@/assets/apps/total_consultant_offline.svg')
                                    "
                                    height="45"
                                    width="45"
                                />
                            </div>
                            <div>
                                <div class="grey--text font-size-12">
                                    Total Konsultan Offline
                                </div>
                                <div
                                    class="font-weight-bold black--text mt-1 font-size-24"
                                >
                                    {{ formatNumber(data.offline) }}
                                    <span class="font-size-12 font-weight-500">
                                        Konsultan
                                    </span>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </section>
    </div>
</template>

<script>
export default {
    name: "consultant-management-statistic",
    props: {
        data: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        };
    },

    methods: {
        formatNumber(value = 0) {
            return new Intl.NumberFormat("id-ID", {
                maximumFractionDigits: 0,
            }).format(value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// ConsultantManagementStatistic.vue?41e47a3e